var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"size":"mini","placeholder":_vm.placeholder,"clearable":_vm.clearable,"show-all-levels":_vm.showAllLevels,"props":_vm.cascaderProps},on:{"change":_vm.updateList},model:{value:(_vm.selfList),callback:function ($$v) {_vm.selfList=$$v},expression:"selfList"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }